// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionCard_container__jJhlO{
    position: relative;
    width: calc(100% - 50px);
    padding: 24px 25px 24px 25px;
    border: 1px solid #1F363D1A;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.ActionCard_totalRaisedAmount__CcRqG{
    margin-right: 5px;
    color: #1F363D;
    font-size: 31px;
    font-family: 'Gotham Bold', serif;
}
.ActionCard_totalRaisedText__sEcYW{
    color: #40798C;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
}
.ActionCard_totalRaisedText__sEcYW.ActionCard_canBeUpdated__o-fZf{
    display: inline-block;
    padding-right: 30px;
}
@media(max-width: 420px){
    .ActionCard_totalRaisedText__sEcYW.ActionCard_canBeUpdated__o-fZf{
        display: block;
        margin-top: 5px;
        padding-right: 0;
    }
}
.ActionCard_progress__TjvU-{
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin-top: 10px;
}
.ActionCard_progressBar__os2-3{
    height: 8px;
    width: 90%;
    margin-top: 8px;
    background-color: #ECECEC;
    border-radius: 500px;
}
@media(max-width: 1080px){
    .ActionCard_progressBar__os2-3{
        width: 100%;
    }
}
.ActionCard_progressMade__4vwBO{
    height: 100%;
    width: 100%;
    background: linear-gradient(90deg, #BC4749 0%, #FFEC41 49%, #A7C957 100%);
    border-radius: 500px;
}
.ActionCard_totalDonations__RZ2uS{
    display: block;
    margin-top: 7px;
    color: #1F363D80;
    text-align: center;
    font-size: 14px;
}
.ActionCard_donateButton__4MGp6{
    width: 100%;
    margin-top: 20px;
}
.ActionCard_shareButton__94haL, .ActionCard_offlineDonateButton__zBTBM{
    width: 100%;
    margin-top: 15px;
}
@media(max-width: 1080px){
    .ActionCard_donateShareButtons__mZEZn{
        display: flex;
        justify-content: space-between;
        gap: 20px;
    }
    .ActionCard_donateButton__4MGp6, .ActionCard_shareButton__94haL, .ActionCard_offlineDonateButton__zBTBM{
        margin-top: 25px;
    }
}
@media(max-width: 710px){
    .ActionCard_donateShareButtons__mZEZn{
        display: block;
    }
    .ActionCard_donateButton__4MGp6{
        width: 100%;
        margin-top: 20px;
        margin-right: 0;
    }
    .ActionCard_shareButton__94haL, .ActionCard_offlineDonateButton__zBTBM{
        width: 100%;
        margin-top: 15px;
    }
}
.ActionCard_receiptLink__JrRZB{
    display: block;
    width: 100%;
    margin-top: 18px;
    margin-bottom: 8px;
    color: #40798C;
    text-align: center;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
    text-decoration: none;
}
.ActionCard_receipt__xAyWx{
    position: relative;
    top: 5px;
    height: 20px;
    width: 18px;
    margin-right: 5px;
}
.ActionCard_donations__whN8c{
    margin-top: 10px;
}
.ActionCard_donationsButtons__i567-{
    display: flex;
    margin-top: 10px;
}
.ActionCard_seeAllButton__o3sBD, .ActionCard_topDonorsButton__-T8Xk{
    width: calc(50% - 5px);
}
.ActionCard_seeAllButton__o3sBD{
    margin-right: 10px;
}
@media(min-width: 601px) and (max-width: 1080px){
    .ActionCard_seeAllButton__o3sBD, .ActionCard_topDonorsButton__-T8Xk{
        width: calc(50% - 10px);
    }
    .ActionCard_seeAllButton__o3sBD{
        margin-right: 20px;
    }
}
.ActionCard_pencil__27JWF{
    position: absolute;
    right: 28px;
    top: 28px;
    height: 16px;
    width: 16px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/fundraiser/ActionCard.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI,YAAY;IACZ,WAAW;IACX,yEAAyE;IACzE,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI;QACI,aAAa;QACb,8BAA8B;QAC9B,SAAS;IACb;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ;AACA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mCAAmC;IACnC,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,WAAW;IACX,eAAe;AACnB","sourcesContent":[".container{\n    position: relative;\n    width: calc(100% - 50px);\n    padding: 24px 25px 24px 25px;\n    border: 1px solid #1F363D1A;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.totalRaisedAmount{\n    margin-right: 5px;\n    color: #1F363D;\n    font-size: 31px;\n    font-family: 'Gotham Bold', serif;\n}\n.totalRaisedText{\n    color: #40798C;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n}\n.totalRaisedText.canBeUpdated{\n    display: inline-block;\n    padding-right: 30px;\n}\n@media(max-width: 420px){\n    .totalRaisedText.canBeUpdated{\n        display: block;\n        margin-top: 5px;\n        padding-right: 0;\n    }\n}\n.progress{\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    margin-top: 10px;\n}\n.progressBar{\n    height: 8px;\n    width: 90%;\n    margin-top: 8px;\n    background-color: #ECECEC;\n    border-radius: 500px;\n}\n@media(max-width: 1080px){\n    .progressBar{\n        width: 100%;\n    }\n}\n.progressMade{\n    height: 100%;\n    width: 100%;\n    background: linear-gradient(90deg, #BC4749 0%, #FFEC41 49%, #A7C957 100%);\n    border-radius: 500px;\n}\n.totalDonations{\n    display: block;\n    margin-top: 7px;\n    color: #1F363D80;\n    text-align: center;\n    font-size: 14px;\n}\n.donateButton{\n    width: 100%;\n    margin-top: 20px;\n}\n.shareButton, .offlineDonateButton{\n    width: 100%;\n    margin-top: 15px;\n}\n@media(max-width: 1080px){\n    .donateShareButtons{\n        display: flex;\n        justify-content: space-between;\n        gap: 20px;\n    }\n    .donateButton, .shareButton, .offlineDonateButton{\n        margin-top: 25px;\n    }\n}\n@media(max-width: 710px){\n    .donateShareButtons{\n        display: block;\n    }\n    .donateButton{\n        width: 100%;\n        margin-top: 20px;\n        margin-right: 0;\n    }\n    .shareButton, .offlineDonateButton{\n        width: 100%;\n        margin-top: 15px;\n    }\n}\n.receiptLink{\n    display: block;\n    width: 100%;\n    margin-top: 18px;\n    margin-bottom: 8px;\n    color: #40798C;\n    text-align: center;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n    text-decoration: none;\n}\n.receipt{\n    position: relative;\n    top: 5px;\n    height: 20px;\n    width: 18px;\n    margin-right: 5px;\n}\n.donations{\n    margin-top: 10px;\n}\n.donationsButtons{\n    display: flex;\n    margin-top: 10px;\n}\n.seeAllButton, .topDonorsButton{\n    width: calc(50% - 5px);\n}\n.seeAllButton{\n    margin-right: 10px;\n}\n@media(min-width: 601px) and (max-width: 1080px){\n    .seeAllButton, .topDonorsButton{\n        width: calc(50% - 10px);\n    }\n    .seeAllButton{\n        margin-right: 20px;\n    }\n}\n.pencil{\n    position: absolute;\n    right: 28px;\n    top: 28px;\n    height: 16px;\n    width: 16px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ActionCard_container__jJhlO`,
	"totalRaisedAmount": `ActionCard_totalRaisedAmount__CcRqG`,
	"totalRaisedText": `ActionCard_totalRaisedText__sEcYW`,
	"canBeUpdated": `ActionCard_canBeUpdated__o-fZf`,
	"progress": `ActionCard_progress__TjvU-`,
	"progressBar": `ActionCard_progressBar__os2-3`,
	"progressMade": `ActionCard_progressMade__4vwBO`,
	"totalDonations": `ActionCard_totalDonations__RZ2uS`,
	"donateButton": `ActionCard_donateButton__4MGp6`,
	"shareButton": `ActionCard_shareButton__94haL`,
	"offlineDonateButton": `ActionCard_offlineDonateButton__zBTBM`,
	"donateShareButtons": `ActionCard_donateShareButtons__mZEZn`,
	"receiptLink": `ActionCard_receiptLink__JrRZB`,
	"receipt": `ActionCard_receipt__xAyWx`,
	"donations": `ActionCard_donations__whN8c`,
	"donationsButtons": `ActionCard_donationsButtons__i567-`,
	"seeAllButton": `ActionCard_seeAllButton__o3sBD`,
	"topDonorsButton": `ActionCard_topDonorsButton__-T8Xk`,
	"pencil": `ActionCard_pencil__27JWF`
};
export default ___CSS_LOADER_EXPORT___;
